import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor, AgHtmlCellRenderer } from 'jk-service';
import { Mtrwc } from '../entity/Mtrwc-angular';


@Injectable({
  providedIn: 'root'
})
export class MtrwcServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'WC001=WB001,WC002=WB002';
    this.defaultItem = new Mtrwc();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      WC001: '單別', WC002: '單號', WC003: '序號', WC004: '日期', WC005: '問題敘述說明', WC006: '處理說明'
    };

    this.fieldNames = 'WC001,WC002,WC003,WC004,WC005,WC006';
    this.fieldLengths = { WC001: 4, WC002: 11, WC003: 4, WC004: 8, WC005: 0, WC006: 0 };
    this.columnDefs = [
      { field: "WC003", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WC004", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "WC005", headerName: "問題敘述說明", headerTooltip: "", width: 300, cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WC006", headerName: "處理說明", headerTooltip: "", width: 300, cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgHtmlCellRenderer, },
      { field: "WC001", headerName: "單別", headerTooltip: "", width: 102, cellDataType: "text", hide: true },
      { field: "WC002", headerName: "單號", headerTooltip: "", width: 158, cellDataType: "text", hide: true },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'MTRWC';
    this.isSys = false;
    this.sqlSelect = `SELECT MTRWC.*  FROM MTRWC`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY WC001,WC002,WC003`;
    this.keyFields = ['WC001', 'WC002', 'WC003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['WC001', 'WC002', 'WC003', 'WC004', 'WC005'];
    this.seqField = 'WC003';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Mtrwc): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Mtrwc): Promise<Mtrwc> {
    await super.newRecord(newItem);
    return newItem;
  }




}

